// extracted by mini-css-extract-plugin
export default {"root":"SearchModuleSpecialRates_root__1IfVG","link":"SearchModuleSpecialRates_link__5xmTJ"};